import { createFileRoute } from "@tanstack/react-router";
import AdminClientDetail from "@/pages/admin/AdminClientDetail";

export const Route = createFileRoute("/admin/crm/$userId/")({ component: AdminClientDetail });
